webpackJsonp([63532597301363],{

/***/ 648:
/***/ (function(module, exports) {

	module.exports = {"data":{"projectsJson":{"name":"Ragdoll Golf","keywords":["Unity","VR","Fuse","Will Smith"],"status":["shipped","green"],"tagline":"You are Will Smith. All you want is to get to the hole. But the hole is just a big orange cylinder. And you are just a ragdoll.","year":[2015],"description":"Inspired by [Cat with Bow Golf](http://www.addictinggames.com/sports-games/catwithbowgolf.jsp), this is a mini-game demo I created with Unity for Google Cardboard.","images":["ragdollGolf.PNG"],"videos":null,"id":"/Users/davidbaker/code/davidbaker.is/src/data/projects.json absPath of file [12] >>> JSON","logo":null,"link":"https://play.google.com/store/apps/details?id=com.BrainsAndSpace.ragdollGolf&hl=en","linkToSource":null,"linkToTrello":null,"callToAction":"Get it while its hot!","teammates":null,"agency":null}},"pathContext":{"projectPath":"nostalgic-about-cat-with-bow-golf"}}

/***/ })

});


// WEBPACK FOOTER //
// path---nostalgic-about-cat-with-bow-golf-bcec976fad837efe4a42.js